import AppIcon from "../../AppIcon.vue";
import FlexRow from "../../FlexRow.vue";
import { TextValue } from "../../tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
export default {
  name: "AdFormatFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    name: String,
    ad_format: String,
    selected: Boolean,
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue,
    FlexRow,
    AppIcon
  }
};